import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Boolean"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.25 6C1.25 3.37665 3.37665 1.25 6 1.25H18C20.6234 1.25 22.75 3.37665 22.75 6C22.75 8.62336 20.6234 10.75 18 10.75H6C3.37665 10.75 1.25 8.62336 1.25 6ZM6 2.75C4.20507 2.75 2.75 4.20507 2.75 6C2.75 7.79493 4.20507 9.25 6 9.25H18C19.7949 9.25 21.25 7.79494 21.25 6C21.25 4.20507 19.7949 2.75 18 2.75H6Z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.25 18C1.25 15.3766 3.37665 13.25 6 13.25H18C20.6234 13.25 22.75 15.3766 22.75 18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18ZM6 14.75C4.20507 14.75 2.75 16.2051 2.75 18C2.75 19.7949 4.20507 21.25 6 21.25H18C19.7949 21.25 21.25 19.7949 21.25 18C21.25 16.2051 19.7949 14.75 18 14.75H6Z"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ _createElementVNode("path", { d: "M17.9998 7.49902C18.8282 7.49902 19.4998 6.82747 19.4998 5.99902C19.4998 5.17057 18.8282 4.49902 17.9998 4.49902C17.1713 4.49902 16.4998 5.17057 16.4998 5.99902C16.4998 6.82747 17.1713 7.49902 17.9998 7.49902Z" }, null, -1);
const _hoisted_5 = /* @__PURE__ */ _createElementVNode("path", { d: "M5.99976 19.499C6.82821 19.499 7.49976 18.8275 7.49976 17.999C7.49976 17.1706 6.82821 16.499 5.99976 16.499C5.17131 16.499 4.49976 17.1706 4.49976 17.999C4.49976 18.8275 5.17131 19.499 5.99976 19.499Z" }, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Boolean.vue"]]);
